import * as React from 'react';

import { ScrollArea as ThemeScrollArea } from '@radix-ui/themes';

export interface ScrollAreaProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  scrollbars?: 'horizontal' | 'vertical' | 'both' | undefined;
  type?: 'auto' | 'always' | 'scroll' | 'hover';
}

export const ScrollArea: React.FC<ScrollAreaProps> = ({
  children,
  style,
  className,
  scrollbars = 'both',
  type = 'auto',
  ...rest
}) => {
  return (
    <ThemeScrollArea
      type={type}
      scrollbars={scrollbars}
      style={{ width: '100%', height: '100%', ...style }}
      className={className}
      {...rest}
    >
      {children}
    </ThemeScrollArea>
  );
};
